import MuiAccordionDetails from '@mui/material/AccordionDetails'
import { FC } from 'react'

import { AccordionDetailsProps } from './accordion-details.types'

export const AccordionDetails: FC<AccordionDetailsProps> = ({ children, ...props }) => {
  return <MuiAccordionDetails {...props}>{children}</MuiAccordionDetails>
}
